import { useAuth0User } from './useAuth0User';

export const useRoles = () => {
  const { auth0User, isAuthenticated } = useAuth0User();
  return { isAuthenticated, roles: auth0User?.roles };
};
